import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './FlashSaleStrip.css';

/**
 * Flash sale banner — surfaces an active sitewide coupon or a featured
 * limited-time offer at the top of the page. Auto-hides when nothing's
 * running so it doesn't take up space without value.
 *
 * Reads from /api/coupons/featured (returns the most-promoted active code).
 */
export default function FlashSaleStrip() {
  const [offer, setOffer] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    fetch('/api/coupons/featured')
      .then(r => r.ok ? r.json() : null)
      .then(setOffer)
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!offer?.valid_until) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [offer]);

  if (!offer || !offer.code) return null;
  const expiresAt = offer.valid_until ? Date.parse(offer.valid_until) : null;
  if (expiresAt && expiresAt < now) return null;

  const remaining = expiresAt ? formatRemaining(expiresAt - now) : null;
  const label = offer.discount_type === 'percentage'
    ? `${Number(offer.discount_value)}% OFF`
    : `$${Number(offer.discount_value).toFixed(2)} OFF`;

  return (
    <Link to="/shop" className="flash-sale-strip" aria-label={`Use code ${offer.code} for ${label}`}>
      <span className="flash-sale-strip__pulse" />
      <strong>{label}</strong>
      <span className="flash-sale-strip__divider">·</span>
      <span>Use code <code>{offer.code}</code></span>
      {remaining && (
        <>
          <span className="flash-sale-strip__divider">·</span>
          <span className="flash-sale-strip__time">Ends in {remaining}</span>
        </>
      )}
      <span className="flash-sale-strip__cta">Shop now →</span>
    </Link>
  );
}

function formatRemaining(ms) {
  if (ms <= 0) return '0s';
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${sec}s`;
  return `${sec}s`;
}
